<script>
import baseMixin from '@mixins/baseMixin'
import { mapGetters } from 'vuex'
import NavDrawerProfile from './nav-drawer-profile.vue'
import NavDrawerSignoutButton from './nav-drawer-signout-button.vue'

export default {
  name: 'NavDrawerProfileActionsContainer',
  components: {
    NavDrawerProfile,
    NavDrawerSignoutButton,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    containerClasses() {
      return {
        'd-flex align-center pb-3': true,
        'px-4 pt-2': this.isMobileViewPort,
        'flex-column flex-wrap justify-center nav-btn':
          !this.isMobileViewPort && this.mini,
      }
    },
  },
}
</script>

<template>
  <div :class="containerClasses">
    <NavDrawerProfile />

    <NavDrawerSignoutButton v-if="mini" />
  </div>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';
</style>
